module.exports = __webpack_public_path__ + "static/mobile-0e2ef6d721483fe6189527b9a495c130.png";